import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import authenticationStore from './AuthenticationStore'
import crudStore from './CrudStore'
import sectionsStore from './SectionsStore'

Vue.use(Vuex)

const mainStore = new Vuex.Store({
  modules: {
    authentication: authenticationStore,
    crud: crudStore,
    sections: sectionsStore
  }
})

export default mainStore
